import * as mailListSelectionActionsV2 from 'owa-mail-actions/lib/mailListSelectionActions';
import { orchestrator } from 'satcheljs';
import { getItemToShowFromNodeId } from 'owa-mail-store/lib/utils/conversationsUtils';
import {
    lazySetAutoMarkAsReadTimer,
    lazyClearAutoMarkAsReadTimer,
} from 'owa-mail-mark-read-actions';

/**
 * Called when the item part is selected in the list view
 */
orchestrator(mailListSelectionActionsV2.singleSelectItemPart, actionMessage => {
    const item = getItemToShowFromNodeId(actionMessage.nodeIdToSelect);
    if (item) {
        lazyClearAutoMarkAsReadTimer.importAndExecute();
        lazySetAutoMarkAsReadTimer.importAndExecute(item.ItemId.Id, true /* isItemPart */);
    }
});
